import React from "react";

const Terms = ({ setOpenTerms }) => {
	return (
		<div className="terms">
			<div className="terms__box">
				<p className="text-center bold">Terms and conditions*</p>
				<div className="close-btn" onClick={() => setOpenTerms(false)}>
					<i className="fa-solid fa-xmark"></i>
				</div>
				<ul>
					<li>
						You can have multiple entries from different login accounts but only
						one unique wallet address will be considered for the WL spot. 
					</li>

					<li>
						Performing tasks only qualifies you to be eligible to win a
						Whitelist spot, it is not a guarantee
					</li>
					<li>
						In the event that the user does not win a spot on the whitelist, the
						amount sent in ETH will be returned to the same wallet address from
						which it was sent. Regardless of the value of the ETH. Example- You
						will receive 0.01 ETH if you send 0.01 ETH 
					</li>
					<li>
						You can skip the optional steps, however, performing those will get
						you closer to winning the whitelist spot
					</li>
					<li>
						Any wrong information, invalid entries or incomplete tasks (for
						mandatory tasks) will lead to disqualification. No dispute will be
						entertained. 
					</li>

					<li>
						Filling out the right information is the sole responsibility of the
						user. Giving inaccurate information will not be resolved later. 
					</li>
					<li>
						Please make sure you use the link provided on our website only,
						Nitro Network is not responsible for any registration done
						elsewhere. 
					</li>

					<li>
						Be aware of fraud links and the whitelist process, join our official
						community group to clear any doubts Nitro Network reserve the right
						to close the whitelisting process at any time
					</li>
				</ul>
			</div>
		</div>
	);
};

export default Terms;
